import React from 'react';
import { iconWrapper, InjectedProps } from '../iconWrapper';

interface Props extends InjectedProps {
  className?: string;
}

class EyeCrossed extends React.PureComponent<Props> {
  public render() {
    return (
      <svg
        className={['icon-svg', 'svg-eye-crossed', this.props.className].join(' ')}
        width={this.props.width}
        height={this.props.height}
        viewBox="0 0 24 24"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.6607 5C14.5384 5 17.0776 6.0674 19.2457 7.83226C20.4506 8.81311 21.3067 9.79651 21.7721 10.4727L21.8659 10.6127C22.469 11.411 22.4677 12.6204 21.8953 13.3435C21.4185 14.0738 20.5297 15.1255 19.2404 16.1742C17.0754 17.9351 14.5381 19 11.6607 19C8.78312 19 6.24391 17.9326 4.0758 16.1677C2.79942 15.1287 1.9145 14.0869 1.43268 13.3563C0.852571 12.5581 0.861141 11.3703 1.42618 10.6565C1.90301 9.92623 2.7918 8.87453 4.08114 7.82584C6.24611 6.06493 8.78341 5 11.6607 5ZM11.6607 7C9.28808 7 7.17642 7.88629 5.34312 9.37741C4.69449 9.90499 4.12895 10.4712 3.65187 11.0357L3.51904 11.1955L3.2963 11.4778L3.12218 11.7161C3.09664 11.7525 3.07269 11.7873 3.05012 11.8207C2.99173 11.8951 2.9915 12.1024 3.0513 12.1815L3.18808 12.3781L3.33422 12.5728L3.52845 12.816C3.56479 12.8602 3.60312 12.9062 3.64341 12.9539C4.12174 13.52 4.68855 14.0877 5.3384 14.6167C7.17484 16.1115 9.28837 17 11.6607 17C14.0334 17 16.1451 16.1137 17.9784 14.6226C18.627 14.095 19.1925 13.5288 19.6696 12.9643L19.8025 12.8045L20.0252 12.5222L20.1993 12.2839C20.2249 12.2475 20.2488 12.2127 20.2714 12.1793C20.3298 12.1049 20.33 11.8976 20.2309 11.7625L20.1334 11.6219L19.9873 11.4272L19.793 11.184C19.7567 11.1398 19.7184 11.0938 19.6781 11.0461C19.1997 10.48 18.6329 9.91232 17.9831 9.38334C16.1466 7.88846 14.0331 7 11.6607 7ZM11.6607 8C13.8699 8 15.6607 9.79086 15.6607 12C15.6607 14.2091 13.8699 16 11.6607 16C9.45161 16 7.66075 14.2091 7.66075 12C7.66075 9.79086 9.45161 8 11.6607 8ZM11.6607 10C10.5562 10 9.66075 10.8954 9.66075 12C9.66075 13.1046 10.5562 14 11.6607 14C12.7653 14 13.6607 13.1046 13.6607 12C13.6607 10.8954 12.7653 10 11.6607 10Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.7143 4.28575C20.0952 4.66675 20.0952 5.28447 19.7143 5.66547L5.66547 19.7143C5.28447 20.0952 4.66675 20.0952 4.28575 19.7143C3.90475 19.3333 3.90475 18.7155 4.28575 18.3345L18.3345 4.28575C18.7155 3.90475 19.3333 3.90475 19.7143 4.28575Z"
          fill="currentColor"
          stroke="white"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.7143 4.28575C20.0952 4.66675 20.0952 5.28447 19.7143 5.66547L5.66547 19.7143C5.28447 20.0952 4.66675 20.0952 4.28575 19.7143C3.90475 19.3333 3.90475 18.7155 4.28575 18.3345L18.3345 4.28575C18.7155 3.90475 19.3333 3.90475 19.7143 4.28575Z"
          fill="currentColor"
        />
      </svg>
    );
  }
}

export const icon = iconWrapper(EyeCrossed);
